import { useCacheStore } from '@/store'
import { ROUTE_PATH } from '@/utils/constants'
import { checkHaveChangePasswordToken, checkHaveToken, clearToken } from '@/utils/token'
import { isAllowedBlankRedirectId } from '@/utils/blank-redirect-allowlist'
import { useCookie } from '@/@core/composable/useCookie'
import { ability, updateAbilityFromCookie, getAbilityRulesFromCookie, clearAbilityRulesCookie } from '@/plugins/ability'

export const setupGuards = router => {
  const unAuthenticatedPages = ['login', 'forgot-pwd', 'create-account', 'forgotPwd', 'change-pwd', 'blank']

  router.beforeEach((to, from, next) => {
    const isLoggedIn = !!checkHaveToken()
    const hasChangePasswordToken = checkHaveChangePasswordToken()

    if (isLoggedIn) {
      updateAbilityFromCookie()
      if (getAbilityRulesFromCookie().length === 0) {
        clearToken()
        clearAbilityRulesCookie()
        return next({ path: ROUTE_PATH.LOGIN })
      }

      if (unAuthenticatedPages.includes(to.name)) {
        if (to.name === 'blank' && isAllowedBlankRedirectId(to.query.id)) {
          return next()
        }

        return next({ path: ROUTE_PATH.HOME })
      }

      // Fine-grained authorization: routes with meta.action/meta.subject require ability check
      const action = to.meta?.action
      const subject = to.meta?.subject
      if (action != null && subject != null && !ability.can(action, subject)) {
        return next({ path: ROUTE_PATH.HOME })
      }

      return next()
    }

    if (hasChangePasswordToken) {
      if (to.name === 'change-pwd' || to.name === 'blank') {
        return next()
      }

      return next({ path: ROUTE_PATH.CHANGE_PWD })
    }

    if (!unAuthenticatedPages.includes(to.name)) {
      return next({ path: ROUTE_PATH.LOGIN })
    }

    return next()
  })


  router.afterEach(() => {
    const { changeGlobalLoading } = useCacheStore()
    changeGlobalLoading(false)
  })
}
